export default __webpack_public_path__ + "static/media/fordata-red-white.6141e63f.png";